import { render, staticRenderFns } from "./LichSuDangKy.vue?vue&type=template&id=15148cc3&scoped=true&"
import script from "./LichSuDangKy.vue?vue&type=script&lang=js&"
export * from "./LichSuDangKy.vue?vue&type=script&lang=js&"
import style0 from "./LichSuDangKy.vue?vue&type=style&index=0&id=15148cc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15148cc3",
  null
  
)

export default component.exports